import * as $ from 'jquery';
import * as React from 'react';
import Component from '../../Component';
import { fullNameFactory } from '../../Factories';
import { STATUS, SUBSIDIARYTABS } from '../../General';
import { getURLParameter } from '../../Utils';
import Header from './Header/Header';
import Members from './Members/Members';
import Settings from './Settings/Settings';

export default class Subsidiary extends Component {
    constructor(props?: any) {
        super(props);
        this.state = {
            subsidiary: {
                value: undefined,
                status: STATUS.LOADING
            },
            currentTab: this.getCurrentTab(SUBSIDIARYTABS.SETTINGS, SUBSIDIARYTABS),
        };
    }

    componentDidMount() {
        this.getSubsidiary();
    }

    getSubsidiary() {
        this.setState(
            {
                subsidiary: {
                    value: this.state.subsidiary.value,
                    status: STATUS.LOADING
                }
            },
            () => {
                $.ajax({
                    type: 'GET',
                    contentType: 'application/json',
                    url: this.Endpoints().getSubsidiary(getURLParameter('id')),
                    dataType: 'json',
                    cache: false,
                    success: (data, textStatus, jqXHR) => {
                        const session = this.getSession().getState() as any;
                        data.manager.fullName = fullNameFactory(data.manager, session.company.nameFormat);
                        this.setState({
                            subsidiary: {
                                value: data,
                                status: STATUS.READY
                            }
                        });
                    },
                    error: (jqXHR, textStatus, errorThrown) => {
                        this.ajaxError(jqXHR, textStatus, errorThrown);
                        this.setState({
                            subsidiary: {
                                value: undefined,
                                status: STATUS.ERROR
                            },
                        });
                    },
                });
            }
        );
    }

    render() {
        const session: any = this.getSession().getState();
        const caches: any = this.getCaches().getState();
        let ready = session.status === STATUS.READY &&
            caches.users.status === STATUS.READY &&
            caches.countries.status === STATUS.READY &&
            this.state.subsidiary.status === STATUS.READY;
        if (ready === false) {
            return this.renderLoading();
        }
        return <div className="container-fluid">
            <div className="row">
                {this.getTab()}
            </div>
        </div>
    }

    getTab() {
        const defaultArgs: any = {
            subsidiary: this.state.subsidiary.value,
            currentTab: this.state.currentTab,
            onTabChange: (tab: any) => { this.setState({ currentTab: tab }); }
        };
        switch (this.state.currentTab) {
            case SUBSIDIARYTABS.MEMBERS:
                return <div className="w-100">
                    <Header {...defaultArgs} />
                    <div className="col-12 mb-3">
                        <Members subsidiary={this.state.subsidiary.value} />
                    </div>
                </div>
            case SUBSIDIARYTABS.SETTINGS:
            default:
                return <Settings
                    {...defaultArgs}
                    onRefresh={() => { this.getSubsidiary(); }}
                />
        }
    }
}